import(/* webpackMode: "eager" */ "/vercel/path0/src/app/discover/most_view/page.tsx");
